import React, { useState } from "react";
import { Card, Typography, Button, Tabs } from "antd";
import { ApiOutlined } from "@ant-design/icons";
import { useGlobal } from "../contexts/GlobalContext";
import MCPBanner from "../componets/mcp/MCPBanner";
import MCPServerTab from "../componets/mcp/MCPServerTab";
import MCPClientTab from "../componets/mcp/MCPClientTab";
import MCPMarketplaceTab from "../componets/mcp/MCPMarketplaceTab";
import { useTranslation } from "../i18n";

const { Title, Paragraph } = Typography;

const MCPServer: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useGlobal();
  const [activeTab, setActiveTab] = useState<string>("server");

  // MCP 客户端为 Pro Max 及以上（vip_level >= 2）能力
  const hasMcpClientAccess = (user?.apiInfo?.postchat.vip_info.level || 0) >= 2;

  const showVipLimit = activeTab === "client" && !hasMcpClientAccess;

  // 需要 Pro Max 及以上的提示组件
  const RequireVipNotice = () => (
    <Card style={{ textAlign: "center", padding: "40px 20px" }}>
      <ApiOutlined
        style={{ fontSize: 64, color: "#bfbfbf", marginBottom: 24 }}
      />
      <Title level={3}>{t("mcpServer.needVip")}</Title>
      <Paragraph type="secondary" style={{ marginBottom: 32 }}>
        {t("mcpServer.vipDesc")}
      </Paragraph>
      <Button
        type="primary"
        size="large"
        onClick={() => (window.location.href = "/console")}
        style={{ minWidth: 200 }}
      >
        {t("mcpServer.backHome")}
      </Button>
    </Card>
  );

  return (
    <div
      style={{
        background: "#f0f2f5",
        minHeight: "100%",
        padding: "16px",
        borderRadius: 8,
      }}
    >
      {/* 统一的顶部Banner */}
      <MCPBanner />

      {/* 标签页切换 */}
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="card"
        size="large"
        style={{ marginBottom: 16 }}
        items={[
          {
            key: "server",
            label: (
              <span>
                <i className="ri-server-line" style={{ marginRight: 8 }} />
                {t("mcpServer.serverTab")}
              </span>
            ),
            children: <MCPServerTab />,
          },
          {
            key: "marketplace",
            label: (
              <span>
                <i className="ri-store-2-line" style={{ marginRight: 8 }} />
                MCP 广场
              </span>
            ),
            children: <MCPMarketplaceTab />,
          },
          {
            key: "client",
            label: (
              <span>
                <i className="ri-computer-line" style={{ marginRight: 8 }} />
                {t("mcpServer.clientTab")}
              </span>
            ),
            children: showVipLimit ? <RequireVipNotice /> : <MCPClientTab />,
          },
        ]}
      />
    </div>
  );
};

export default MCPServer;
